import { ANALYTICS_VERSION_STACK_CREATION_V3 } from "./constants";

const useStackCreationAnalyticsVersion = () => {
  return ANALYTICS_VERSION_STACK_CREATION_V3;
};

export default useStackCreationAnalyticsVersion;
